// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './vuex/store'
import Vuex from 'vuex'
import less from 'less'
import VueCookies from 'vue-cookies'
// import VConsole from 'vconsole';

Vue.use(VueCookies)
// const vConsole = new VConsole({ theme: 'dark' });
Vue.use(less)
Vue.use(Vuex)
Vue.use(ElementUI);
Vue.config.productionTip = false

// Vue.prototype.imgsrc = 'http://www.sitemerge.com/uploads/';//全局资源路径
Vue.prototype.imgsrc = 'https://cdnunified.liuyanniangzhi.com/uploads/';//全局资源路径
Vue.prototype.imgLoading = 'images/liuyan/94173fbb766e8c707e9bd31b4211c21f.gif';//占位图

// Vue.prototype.fullscreenLoadingF=()=>{
//   Vue.prototype.fullscreenLoading=ElementUI.Loading.service()
// }
// Vue.prototype.fullscreenLoadingF()

// 临时禁用.。。。。。。。。。。。。。。。。。。。

// window.fullscreenLoadingF=()=>{
//   window.fullscreenLoading=ElementUI.Loading.service({lock: true,text: '努力加载中...',})
// }
// window.fullscreenLoadingF()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js